import React, { FC, ReactNode } from 'react';

import { Box, HStack, Stack } from '@chakra-ui/react';

import { PageHeaderWithIcon } from 'components/DataDisplay';
import { IconType } from 'components/Icons';
import { HeaderTable } from 'containers/Inventory/CloudInventory/Components/HeaderTable';

interface Props {
  title: ReactNode | string;
  value: ReactNode;
  iconType: IconType;
}

export const InventoryTableTitle: FC<Props> = props => {
  // onOpenAddWhitelist removed: HeaderTable no longer offers an allow-list button.
  const { title, value, iconType } = props;
  return (
    <Stack w="full" spacing={5}>
      <Box>
        <PageHeaderWithIcon
          label={
            <HStack>
              <Box>{title}:</Box>
              <Box fontWeight={400} color="gray.250">
                {value}
              </Box>
            </HStack>
          }
          iconType={iconType}
          reversed
        />
      </Box>
      <HeaderTable />
    </Stack>
  );
};
